import { useApiUrl, useQuery } from '@gemini/lux-ds-pms';
import { DevicesApiRoutes } from '../routes/routes';
import { QueryKeyList } from './querykeys';
import { AppointmentDTO, PagedResponse } from '@interfaces/interfaces';
import dayjs from 'dayjs';

interface Props {
  organizationCoreId?: string | null;
  locationCoreId?: string | null;
  date?: Date | null;
  enabled?: boolean;
}

export const useGetAppointments = ({
  enabled,
  organizationCoreId,
  locationCoreId,
  date,
}: Props) => {
  const dateIsValid = dayjs(date).isValid();
  const baseUrl = useApiUrl(
    DevicesApiRoutes.GetAppointment,
    'DEVICE_BFF_API_BASE_URL'
  )
    ?.replace('{locationCoreId}', String(locationCoreId))
    ?.concat(
      dateIsValid
        ? `?date=${dayjs(date).format('YYYY-MM-DDT00:00:00.000[Z]')}`
        : ''
    );

  return useQuery<PagedResponse<AppointmentDTO>>(baseUrl || '', {
    enabled:
      !!enabled &&
      !!baseUrl &&
      !!organizationCoreId &&
      !!locationCoreId &&
      !!date,
    queryKey: [
      QueryKeyList.AppointmentQueryKey,
      organizationCoreId,
      locationCoreId,
      date,
    ],
  });
};

export default useGetAppointments;
